<template>
  <v-container class="fill-height">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="6">
        <v-card flat class="pa-6 elevation-10">
          <v-card-title primary-title>
            <h4>Login</h4>
          </v-card-title>
          <v-form >
            <v-text-field v-model="email" prepend-icon="person" name="Email" label="Email" required></v-text-field>
            <v-text-field v-model="password" prepend-icon="lock" name="Password" label="Password" type="password" required></v-text-field>
            <v-alert
              dense
              outlined
              type="error"
              v-for="(error, index) in errors"
              :key="index"
            >
              {{ error }}
            </v-alert>
            <v-card-actions>
              <v-btn color="primary" class="rounded-lg" large block @click="login" :disabled="email === '' || password === ''">Login</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      errors: []
    }
  },
  methods: {
    login: function () {
      this.errors = []
      let email = this.email
      let password = this.password
      this.$store.dispatch('login', { email, password })
        .then(() => this.$router.push('/'))
        .catch(err => {
          this.errors.push(err)
        })
    }
  }
}
</script>